import { tenderAIAPi } from './tender-ai-api';
import LocalStorageService from '../application/features/common/local-storage-service';
import axios from 'axios';
const baseURL = process.env.REACT_APP_API_BASE_URL;
const login = () => {
    const token = LocalStorageService.getMSAccessToken(); // Retrieve the token from localStorage
    if (!token) {
        throw new Error('Token not found in localStorage');
    }
    return axios.get(`${baseURL}/auth/token`, {
        headers: {
            Authorization: `Bearer ${token}` // Attach the token with the "Bearer " prefix
        }
    });
};
const getRefreshToken = (refreshToken) => {
    return tenderAIAPi.post('auth/refresh', refreshToken);
};
const verifyToken = (refreshToken) => {
    return tenderAIAPi.post('token/verify-token', refreshToken);
};
const AuthApi = {
    login,
    getRefreshToken,
    verifyToken
};
export default AuthApi;
